import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Switch} from "react-router-dom";
import Loading from './components/loading';
import routes from "./routes";
import {setAccessToken, setCanteenId, setEnv} from '@global'
import {constant} from '@const'

if (window.yiwo && window.yiwoAppJsChannel) {
  window.yiwo.initSDK({
    success: res => {
      setAccessToken(res.token || '')
      setEnv(res.env || constant.UAT)
      setCanteenId(res.canteenId || null)
      if (res.debug) import('mdebug').then(mdebug => mdebug.init())
    }
  })
}

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<Loading />}>
      <BrowserRouter>
        <Switch>
          {routes}
        </Switch>
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
